<div class="main">
    <app-header-section></app-header-section>
    <app-breadcrumb-create></app-breadcrumb-create>
    <app-create-section></app-create-section>
    <app-footer-section></app-footer-section>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
    <app-scrollup></app-scrollup>
</div>
